export default "__VITE_ASSET__BspWsqlr__"